export const algorithmNames = [
  '人员及设备规划算法',
  '急单识别以及排程算法',
  'MR动力匹配算法',
  '波次分单上架算法',
  '波次分单拣货算法',
  '波次分单补货算法',
  '排序任务优化算法',
  '翻包作业优化算法',
  '自动化设备高度算法',
  '送件上门时间时间优化算法',
  '运输配载优化算法',
  '上线配置优化算法',
  'MR智能配载算法',
  '小火车配载优化算法',
  '售后件智能配载算法',
  '运输路径优化算法',
  '库内动线优化算法',
  'MR线路分配优化算法',
  'MR路径优化算法',
  '高位补超市优化算法',
  '拣货路径优化算法',
  '小火车停靠点及顺序优化算法',
  '空窗口回收路线优化算法',
  '理库作业优化算法',
  '售后路线优化算法',
  '库区及存储位规划算法',
  '仓间调拨优化算法',
  '入库策略优化算法',
  '库存控制优化算法',
  'NDC|RDC分布及网络优化算法',
  '厂内投料点规划算法',
  '订单预测及网络规划算法',
  '采购订单预测算法',
  '急单预测算法',
  '时效预测算法',
  '自动化设备行人安全检测算法',
  '售后运输计划优化算法',
  '售后动态路由算法'
];

export const mechanismModelNames = [
  '路径规划与调度模型',
  '导航算法仿真模型',
  '控制器机理模型',
  '车辆通讯机理模型',
  '避障与路径重规划模型',
  '集群协同作业模型',
  '任务分配与优先级模型',
  '导航精度需求测算模型',
  '能源消耗与充电策略模型',
  'AS/RS存储优化模型',
  'AS/RS设备控制器机理模型',
  'AS/RS设备通讯机理模型',
  'AS/RS空间利用率提升模型',
  'AS/RS订单拣选优化模型',
  '传送带故障预测与维护模型',
  '传送带速度控制与同步模型',
  '传送带系统动态负载平衡模型',
  '吊机设备作业效率分析模型',
  '吊机设备健康监测模型',
  '吊机负载预测模型',
  '循环取货物流模型',
  '运输包装一体化模型',
  '零部件配送中心规划模型',
  '供应链物流优化模型'
];

// Helper function to generate a camelCase identifier from a name
export const toCamelCase = (str: string) => {
  return str.replace(/\|/g, '').replace(/\s+(.)/g, (match, chr) => {
    return chr.toUpperCase();
  }).replace(/\s/g, '').replace(/^(.)/, (match, chr) => {
    return chr.toLowerCase();
  });
};

export const modelDataList = [
  ...algorithmNames.map((name, index) => ({
    key: `algo-${index}`,
    type: '算法模型',
    name: name,
    identifier: toCamelCase(name),
    dataType: '结构化数据',
    accessType: '读写',
    definition: `用于${name.replace(/算法$/, '')}相关的功能`
  })),
  ...mechanismModelNames.map((name, index) => ({
    key: `mech-${index}`,
    type: '机理模型',
    name: name,
    identifier: toCamelCase(name),
    dataType: '结构化数据',
    accessType: '读写',
    definition: `用于${name.replace(/模型$/, '')}相关的功能`
  }))
];